// Polyfills modernos (substituindo babel-polyfill descontinuado)
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import * as serviceWorker from './serviceWorker'
import { recordError, recordEvent } from './observability/events'
import { installGlobalErrorHandlers } from './observability/globalErrorHandlers'
import { startHeartbeat } from './observability/heartbeat'

// import { BrowserRouter } from 'react-router-dom'
import DatabaseProvider from '@nozbe/watermelondb/DatabaseProvider'
import { Provider } from 'react-redux'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import appTheme from './theme'
import database from './database'
import { router } from './router.js'
import { startSyncingLoop } from './syncWorker'
import { store } from './store.js'
import '../src/assets/scss/main.scss'
import clearCache from './utils/clearCache'

//import worker from 'workerize-loader?inline!./syncWorker'

//const syncWorker = worker()

/*syncWorker.addEventListener('message', message => {
  const prefix = 'Message from SyncWorker: '
  const data = `${message.data}`
  if (data.includes('[WARN]')) {
    console.warn(prefix, message.data)
  } else if (data.includes('[ERROR]')) {
    console.error(prefix, message.data)
  } else {
    console.log(prefix, message.data)
  }
})*/

/**
 * Limpeza de dados legados do localStorage
 * Remove dados que causavam QuotaExceededError:
 * - "Registros - *": Backups antigos da funcao backupOnLocalStorage (ja desabilitada)
 * - "sync_logs": Logs persistidos (agora usa apenas console.log)
 */
function cleanupLegacyStorage() {
  try {
    let freedBytes = 0
    let removedKeys = 0

    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i)
      if (key && key.startsWith('Registros - ')) {
        const size = (key.length + (localStorage.getItem(key)?.length || 0)) * 2
        localStorage.removeItem(key)
        freedBytes += size
        removedKeys++
      }
    }

    const logsData = localStorage.getItem('sync_logs')
    if (logsData) {
      const logsSize = logsData.length * 2
      localStorage.removeItem('sync_logs')
      freedBytes += logsSize
      removedKeys++
    }

    if (freedBytes > 0) {
      recordEvent({
        level: 'info',
        category: 'outro',
        action: 'legacy_storage_cleaned',
        payload: {
          freedKb: Math.round(freedBytes / 1024),
          removedKeys,
        },
      })
    }
  } catch (e) {
    console.warn('[index] legacy storage cleanup failed', e)
    recordError(e instanceof Error ? e : new Error(String(e)), {
      category: 'outro',
      action: 'legacy_storage_cleanup_failed',
    })
  }
}

// Migração one-shot: converte localStorage.trackedData (sistema legado)
// em eventos no novo schema. Roda apenas se a chave existir.
async function drainLegacyTrackedData() {
  try {
    const raw = localStorage.getItem('trackedData')
    if (!raw) return

    const items = JSON.parse(raw)
    if (!Array.isArray(items) || items.length === 0) {
      localStorage.removeItem('trackedData')
      return
    }

    const { recordEvent } = await import('./observability/events')

    for (const item of items) {
      // item shape legado: { app, page, date, action, value }
      if (!item || !item.action) continue
      await recordEvent({
        level: 'info',
        category: 'outro',
        action: 'legacy_tracked_event',
        payload: {
          legacyPage: item.page ?? null,
          legacyAction: item.action ?? null,
          legacyValue: item.value ?? null,
          legacyDate: item.date ?? null,
        },
      })
    }

    localStorage.removeItem('trackedData')
    localStorage.removeItem('lastSendTrackedData')

    console.log(
      `[drain] drenados ${items.length} eventos legados para tabela events`,
    )
  } catch (e) {
    console.warn('[drain] falha ao drenar trackedData legado', e)
    // Não remover a chave em caso de falha parcial — tentar novamente na próxima inicialização.
  }
}

// Executar limpeza ANTES de iniciar o sync loop
installGlobalErrorHandlers() // captura global desde o boot
startHeartbeat() // sync_heartbeat: saúde do sync, ≤1/h por aparelho (logado + visível)
cleanupLegacyStorage()
drainLegacyTrackedData() // one-shot: drena localStorage.trackedData legado

startSyncingLoop()

document.documentElement.lang = 'pt-br'

// render the main component (React 18+ root API)
const root = createRoot(document.getElementById('root'))
root.render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={appTheme}>
      <DatabaseProvider database={database}>
        <Provider store={store}>{router}</Provider>
      </DatabaseProvider>
    </ThemeProvider>
  </StyledEngineProvider>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register({ onUpdate: () => clearCache() })
